// Getters
import { filterActiveHistory } from '@modules/back-office/utils/active-history/active-history'

export const activeHistory = (state) => {
  return filterActiveHistory({
    source: state.activeHistory.data,
    removed: state.activeHistory.removed,
  })
}
export const activeHistoryLoading = (state) => {
  return state.activeHistory.loading
}
export const activeHistoryLastUpdate = (state) => {
  return state.activeHistory.lastUpdate
}
export const activeHistoryRemovedIds = (state) => {
  return state.activeHistory.removed || []
}

export const accounts = (state) => {
  return state.accounts.data || []
}
export const accountsLoading = (state) => {
  return state.accounts.loading
}
export const accountsLastUpdate = (state) => {
  return state.accounts.lastUpdate
}

export const activeCurrent = (state) => {
  return state.activeCurrent.data || []
}
export const activeCurrentLoading = (state) => {
  return state.activeCurrent.loading
}
export const activeCurrentLastUpdate = (state) => {
  return state.activeCurrent.lastUpdate
}
export const operations = (state) => {
  return state.operations.data || []
}
export const operationsLoading = (state) => {
  return state.operations.loading
}
export const operationsLastUpdate = (state) => {
  return state.operations.lastUpdate
}

export const operationsBase = (state) => {
  return state.operationsBase.data || []
}
export const operationsBaseLoading = (state) => {
  return state.operationsBase.loading
}
export const operationsBaseLastUpdate = (state) => {
  return state.operationsBase.lastUpdate
}

export const currentStatusStep = (state) => {
  return state.currentStatusStep
}
export const comparisonInvestmentAccounts = (state) => {
  return state.comparisonInvestmentAccounts.data || []
}
export const comparisonInvestmentAccountsLoading = (state) => {
  return state.comparisonInvestmentAccounts.loading
}
export const comparisonInvestmentAccountsLastUpdate = (state) => {
  return state.comparisonInvestmentAccounts.lastUpdate
}

export const suggestions = (state) => {
  return state.suggestions.data || []
}
export const suggestionsLoading = (state) => {
  return state.suggestions.loading
}
export const suggestionsLastUpdate = (state) => {
  return state.suggestions.lastUpdate
}

export const dataRoomLoading = (state) => {
  return !!(state.dataRoomUi && state.dataRoomUi.loading)
}

export const dataRoomFilters = (state) => {
  return state.dataRoomFilters || {}
}
export const dataRoomMonthReferenceBr = (state) => {
  return state.dataRoomFilters && state.dataRoomFilters.monthReferenceBr
    ? state.dataRoomFilters.monthReferenceBr
    : ''
}
